import { getRelnrsString } from "../conversions";
import { getFitDocToken } from "../token";

export const handleGetNewestInvoices = async (user) => {
    
    const token = getFitDocToken(user);
    let dossiermetafilter = "";
    if(parseFloat(user.role) > 1){
        const metafilter = await getRelnrsString(user);
        if(parseFloat(user.role) === 2){
            //EM
            dossiermetafilter = "RELNR_EM="
        }
        else if(parseFloat(user.role) === 3){
            //Afnemer
            dossiermetafilter = "RELNR_AF="
        }
        else if(parseFloat(user.role) === 4){
            //Aanbieder
            dossiermetafilter = "RELNR_AB="
        }

        dossiermetafilter = dossiermetafilter+metafilter
    }

    const body = {
        "token": token,
        "searchstring": "",
        "doctypes": "VFAC",
        "startdate": "",
        "enddate": "",
        "searchcontent": 0,
        "dossiermetafilter": dossiermetafilter
    };
    

    return fetch(process.env.REACT_APP_SERVER_LINK+"getLatestInvoices",{
        method:"POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body)
    }).then(
        resp => resp.json()
    ).then(
        json => { return json }
    )
}

export const handleGetNFUDocs = (user) => {
    
    const token = getFitDocToken(user);

    return fetch(process.env.REACT_APP_SERVER_LINK+"getNFUDocs?token="+token).then(
        resp => resp.json()
    ).then(
        json => { return json }
    )
}